const corporateTaxSelector = (state) => state.corporateTax.corporateTaxes

export { corporateTaxSelector }
